<template>
  <div class="total bgps flex fd">
    <theader />
    <div class="content f1 flex fd" style=" height: 100%;overflow: hidden;">
      <div class="zbbox flex jb ac">
        <div class="zblist" v-for="(i, j) in zbdata" :key="j">
          <div  class="img-back">
            <refreshImg height='100%' :duration='15000' imgUrl="meterial/图标背景.png"></refreshImg>
          </div>
          <img :src="i.url" alt />
          <div>
            <p  style="
              font-size: 1.67vw;
              color: linear-gradient(90deg, #ffffff 0%, #4cbaff 100%);
            "
            >{{ i.value }}</p>
            <p style="font-size: 0.68vw">{{ i.label }}</p>
          </div>
        </div>
      </div>
      <div class="f1 main flex"   style=" height: 100%;overflow: hidden;">
        <div class="f1 mainsingle flex fd" style="gap: 1.04vw;height: 100%;overflow: hidden;">
          <div style="height: 45%;" class="bluebg flex fd">
            <longbluetitle :titlearr="['在岗人员趋势分析']" />
            <div id="firstcharts" class="charts f1"></div>
          </div>
          <div class="f1 flex" style="gap: 1.04vw;height: 50%;">
            <div class="f1 bluebg flex fd">
              <longbluetitle :titlearr="['工种分析']" />
              <div id="secondcharts" class="charts f1" style="margin-top:-8.125rem"></div>
            </div>
            <div class="f1 bluebg flex fd">
              <longbluetitle :titlearr="['安全教育分析']" />
              <div id="thirdcharts" class="charts f1"></div>
            </div>
          </div>
        </div>
        <div class="f1 flex fd " style="gap:1.04vw;flex-direction: column;justify-content: space-between">
          <div v-if="videoData.length!==0" class="mainsingle bluebg flex fd" style="width: 100%;height: 45%;">
            <longbluetitle :titlearr="['闸机监控']" />
            <div class="doorlist">
              <div class="doorsingle" v-for="(i, j) in doordata">
<!--                {{ i.label }}-->
                <div class="staffimg">
                  <vidobox :id="'staffVideo'" :url="videoObj.liveUrl" :width="width" :height="height" :list="videoObj"  :kbottom="'0px'" :token="token"/>
                </div>
              </div>
            </div>
          </div>
          <div class="mainsingle bluebg flex fd f1" :style="videoData.length!==0?'max-height: 52.5%':''" style="width:100%">
            <div class="f1 flex fd" >
              <longbluetitle :titlearr="['实时进出场人员']" />
              <bluetitle :titlearr="titlearr" @tabnum1="tabnum1" style="background: url(''); width: 30%;position: absolute;right: 0;"/>
            </div>
            <div class="inoutlist" style="overflow: auto;">
              <div class="inoutsingle" v-for="(i, j) in inoutdata">
                <img :src="i.photo" alt="" />
                <div class="f1 flex fd" style="margin-left: 3%;">
                  <div class="top flex ac">
                    <p>{{ i.name }}</p>
                    <div
                      style="
                      margin:0 3%;
                        padding: 0 .625rem;
                        background: rgba(17, 80, 138, 0.3);
                        border-radius: 0.21vw;
                        height: 1.25vw;
                        border: 0.05vw solid rgba(131, 166, 199, 0.3);
                        color: #009eff;
                      "
                    >{{ i.jobType }}</div>
                    <div
                      style="
                        padding: 0 0.52vw;
                        border-radius: 0.21vw;
                        height: 1.25vw;
                        line-height: 1.25vw;
                      "
                      :style="{
                        backgroundColor: i.trainingStatus
                          ? 'rgba(17, 80, 138, 0.3)'
                          : 'rgba(183,116,0,0.2)',

                        border: i.trainingStatus
                          ? ' 0.05vw solid rgba(131, 166, 199, 0.3)'
                          : '1px solid rgba(190,134,38,0.3)',
                        color: i.trainingStatus ? '#009EFF' : '#EFA42B',
                      }"
                    >{{ i.trainingStatus ? "已培训" : "未培训" }}</div>
                  </div>
                  <div class="mid">
                    进出场时间：
                    <span style="color: white">{{ i.entryTime }}</span>
                  </div>
                  <div class="fot">
                    当月出勤总工时：
                    <span style="color: white">
                      {{
                      i.attendanceDuration
                      }}
                    </span>
                  </div>
                  <div
                    class="pa"
                    style="
                      position: absolute;
                      top: 0;
                      right: 0;
                      width: 5rem;
                      height: 1.875rem;
                      border-radius: 0px 0.42vw 0px 0.73vw;
                      color: white;
                      text-align: center;
                      line-height: 1.875rem;
                    "
                    :style="{
                      background: i.status=='进场'
                        ? 'linear-gradient( 56deg, #00B4FB 0%, #0254A0 100%)'
                        : 'linear-gradient( 56deg, #F0B964 0%, #9C5C15 100%)',
                    }"
                  >{{ i.status }}</div>
                </div>
              </div>
              <div v-if="inoutdata.length === 0"  class="kongbox">
              <img src="../assets/image/暂无数据1@2x.png" alt="">
                <p>暂无项目数据</p>
             </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <tmenu />
  </div>
</template>

<script>
import * as echarts from "echarts";
import refreshImg from '@/components/common/refreshImg.vue';

export default {
  components:{refreshImg} ,

  data() {
    return {
      videoData:[],
      token:'',
      titlearr: [
        { label: "进场", select: 1 },
        { label: "出场", select: 0 }
      ],
      inoutdata: [],
      doordata: [
        { label: "1号门", src: require("../assets/image/闸机监控.png") }
      ],
      zbdata: [
        {
          label: "实时在岗总人数（人）",
          value: "0",
          url: require("../assets/image/staff/人员.png")
        },
        {
          label: "日累积在岗人数（人）",
          value: "0",
          url: require("../assets/image/staff/人员.png")
        },
        {
          label: "日进场次数（次）",
          value: "0",
          url: require("../assets/image/staff/日进场次数.png")
        },
        {
          label: "日出场次数（次）",
          value: "0",
          url: require("../assets/image/staff/日出场次数.png")
        },
        {
          label: "管理人员月出勤率",
          value: "0",
          url: require("../assets/image/staff/管理出勤.png")
        },
        {
          label: "建筑工人月出勤率",
          value: "0",
          url: require("../assets/image/staff/月出勤率.png")
        }
      ],
      tabnums1:0,
      videoObj:{
      },
      width:0,
      height:0
    };
  },
  methods: {
    getBox(){
      let onebox=document.getElementsByClassName('staffimg')
      this.width = onebox[0].clientWidth;
      this.height = onebox[0].clientHeight;
    },
    tabnum1(e){
      this.tabnums1=e
      this.getrecord()
    },
    async thirdinit() {
      var chartDom = document.getElementById("thirdcharts");
      var myChart = echarts.init(chartDom);
      var res = await this.$https.get(this.$url.realname.staff.train, "");
      console.log(res, "187");
      var xAxisdata = [];
      var seriesdata = [];
      var seriesdata1 = [];
      var all = 0;
      res.data.map((v, i) => {
        xAxisdata.push(v.team);
        seriesdata.push(v.trainedCount); //训练
        seriesdata1.push(v.untrainedCount);
        all = v.totalStaffCount + all;
      });
      console.log(xAxisdata, all, "192");
      var option;
      option = {
          color: ["#4DDCDD", "#F9BF63"],
          legend: {
            data: ["已培训人数", "未培训人数"],

            textStyle: {
                color: "#fff" // 修改图例字体颜色为蓝色
            }
          },
         tooltip: {
              formatter(params) {
                // 返回值就是html代码可以使用标签
                var num = ((params[0].value / all) * 100).toFixed(2);
                return `
                <div style="width: 12.5rem;"><font style="margin-right:55%">班组：</font><span style=" color: #E5F1F8FF;">${params[0].axisValue}</span></div>
                <div style="width: 12.5rem;"><font style="margin-right:25%">培训覆盖率：</font><span style=" color: #E5F1F8FF;">${num}%</span></div>
                <div style="width: 12.5rem;"><font style="margin-right:60%">未培训：</font><span style=" color: #E5F1F8FF;">${params[1].value}</span></div>
                <div style="width: 12.5rem;"><font style="margin-right:60%">已培训：</font><span style=" color: #E5F1F8FF;">${params[0].value}</span></div>
              `;
              },
              trigger: "axis",
              axisPointer: {
                type: "shadow" // 将指示器类型改为线形式
              },
              borderWidth: 0, // 设置提示框边框宽度为0，即没有边框
              backgroundColor: "rgba(0,25,49,0.9)", // 设置提示框背景颜色为半透明黑色
              backdropFilter: 'blur(16px)',
              textStyle: {
                color: "#fff" // 设置提示框文字颜色为白色
              },
            },
         xAxis: {
              type: "category",
              data: xAxisdata,
              axisLabel: {
                rotate: -45
              },
              axisTick: {
            alignWithLabel: true,
            interval: 0, // 设置x轴刻度为1
          },
      },
      yAxis: {
          type: "value",
              max: all,
              min: 0,
              splitLine: {
            show: false,
            lineStyle: {
              color: "#0E2A49",
            },
            axisLine: {
            show: true,
            lineStyle: {
              color: "#0E2A49",
            },
          },
          },

      },
      series: [
        {
          name: "已培训人数",
          type: "bar",
          stack: "总量",
          barWidth: "70%",
          data:seriesdata,
        },
        {
          name: "未培训人数",
          type: "bar",
          stack: "总量",
          barWidth: "70%",
          data:seriesdata1,
        },
      ],
      };//end option

      option && myChart.setOption(option);
    },
    async secondinit() {
      var chartDom = document.getElementById("secondcharts");
      var myChart = echarts.init(chartDom);
      var option;
      console.log(this.$url.realname.staff);
      var res = await this.$https.get(this.$url.realname.staff.check, "");
      let all = 0;
      var dataList = [];
      res.data.map((v, i) => {
        let obj = { value: 0, name: "" };
        obj.value = v.count;
        obj.name = v.vocation;
        dataList.push(obj);
        all = v.count + all;
      });
      console.log(dataList, 293);
      option = {
        title: {
          text: all,
          subtext: "工种总数",
          x: "center",
          y: "40%",
          textStyle: {
            color: "#fff",
            fontSize: 15
          },
          subtextStyle: {
            color: "#fff",
            fontSize: 15
          }
        },
        legend: {
          // orient: 'vertical',
          top: "72%",
          textStyle: {
            color: "#fff" // 修改图例字体颜色为蓝色
          }
        },
        series: [
          {
            name: "Access From",
            type: "pie",
            radius: ["25%", "50%"],
            center: ["50%", "50%"],

            label: {
              show: false,
              position: "center"
            },
            emphasis: {
              label: {
                show: false,
                fontSize: 10,
                fontWeight: "bold"
              }
            },
            labelLine: {
              show: false
            },

            data: dataList
          },
          {
            radius: ["25%", "35%"],
            center: ["50%", "50%"],
            type: "pie",
            label: {
              normal: {
                show: false
              },
              emphasis: {
                show: false
              }
            },
            labelLine: {
              normal: {
                show: false
              },
              emphasis: {
                show: false
              }
            },
            animation: false,
            tooltip: {
              show: false
            },
            itemStyle: {
              normal: {
                color: "rgba(0,0,0,0.5)"
              }
            },
            data: dataList
          }
        ],
        tooltip: {
          formatter(params) {
            return `
              <div style="width: 8.5rem;"><font style="margin-right:40%">${params.name}：</font><span style=" color: #F4F8FAFF;">${params.value}</span></div>
            `;
            },
          // trigger: "axis",
          axisPointer: {
            type: "shadow" // 将指示器类型改为线形式
          },
          borderWidth: 0, // 设置提示框边框宽度为0，即没有边框
          backgroundColor: "rgba(0,25,49,0.9)", // 设置提示框背景颜色为半透明黑色
          backdropFilter: 'blur(16px)',
          textStyle: {
            color: "#fff" // 设置提示框文字颜色为白色
          },
       }
      };//end option

      option && myChart.setOption(option);
    },
    async initfirst() {
      var chartDom = document.getElementById("firstcharts");
      var myChart = echarts.init(chartDom);
      var option;
      var timeData = [];
      var yData = [];
      var res = await this.$https.get(this.$url.realname.staff.graphHour, "");

      res.data.map((v, i) => {
        timeData.push(v.hour);
        yData.push(v.onDutyCount);
      });
      let maxOnDutyCount = Math.max(...res.data.map(item => item.onDutyCount));
      option = {
        // tooltip: {},
        grid: {
          top: "8%",
          left: "1%",
          right: "1%",
          bottom: "8%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            axisLine: {
              //坐标轴轴线相关设置。数学上的x轴
              show: true,
              lineStyle: {
                color: "#233e64",
              },
            },
            axisLabel: {
              //坐标轴刻度标签的相关设置
              textStyle: {
                color: "#6a9cd5",
                margin: 15,
              },
            },
            axisTick: { show: false },
            data: timeData,
          },
        ],
        yAxis: [
          {
            type: "value",
            max: maxOnDutyCount+5,
            min: 0,
            splitNumber: 7,
            splitLine: {
              show: false,
              lineStyle: {
                color: "#233e64",
              },
            },
            axisLine: { show: false },
            axisLabel: {
              margin: 20,
              textStyle: {
                color: "#6a9cd5",
              },
            },
            axisTick: { show: false },
          },
        ],
        series: [
          {
            name: "",
            type: "line",
            smooth: true, //是否平滑曲线显示
            symbol:'circle',  // 默认是空心圆（中间是白色的），改成实心圆
            symbolSize: 5,
            itemStyle: {
              color: "#073375",
              borderColor: "#3deaff",
              borderWidth: 2,
            },
            lineStyle: {
              normal: {
                color: "#3deaff", // 线条颜色
              },
            },
            areaStyle: {
              //区域填充样式
              normal: {
                //线性渐变，前4个参数分别是x0,y0,x2,y2(范围0~1);相当于图形包围盒中的百分比。如果最后一个参数是‘true’，则该四个值是绝对像素位置。
                color: new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    { offset: 0, color: "rgba(61,234,255, 0.9)" },
                    { offset: 0.7, color: "rgba(61,234,255, 0)" },
                  ],
                  false
                ),

                shadowColor: "rgba(53,142,215, 0.9)", //阴影颜色
                shadowBlur: 20, //shadowBlur设图形阴影的模糊大小。配合shadowColor,shadowOffsetX/Y, 设置图形的阴影效果。
              },
            },
            data:yData,
          },
        ],
        tooltip: {
          formatter(params) {
            // 返回值就是html代码可以使用标签
            let currentDate = new Date();
            let year = currentDate.getFullYear();
            let month = currentDate.getMonth() + 1; // 月份是从 0 开始计数的，所以需要加1
            let day = currentDate.getDate();
            return `
            <div style="width: 12.5rem;"><font style="margin-right:40%">日期：</font><span style=" color: #E5F1F8FF;">${year}/${month}/${day}</span></div>
            <div style="width: 12.5rem;"><font style="margin-right:58%">时段：</font><span style=" color: #E5F1F8FF;">${params[0].axisValue}</span></div>
            <div style="width: 12.5rem;"><font style="margin-right:58%">在岗人数：</font><span style=" color: #E5F1F8FF;">${params[0].value}</span></div>
	      		`;
          },
          trigger: "axis",
          axisPointer: {
              type: "shadow" // 将指示器类型改为线形式
          },
          borderWidth: 0, // 设置提示框边框宽度为0，即没有边框
          backgroundColor: "rgba(0,25,49,0.9)", // 设置提示框背景颜色为半透明黑色
          backdropFilter: 'blur(16px)',
          textStyle: {
            color: "#fff" // 设置提示框文字颜色为白色
          },
        }
     };//end option

      option && myChart.setOption(option);
    },
    async getrecord() {
      const map = {
        0:'进场',
        1:'出场'
      }
      var res = await this.$https.get(this.$url.realname.staff.record, `?status=${map[this.tabnums1]}`);

      if(this.tabnums1===0){
        this.inoutdata =res.data.filter(item => item.status === "进场");
      }else{
        this.inoutdata =res.data.filter(item => item.status === "出场");
      }

      console.log( this.inoutdata, " this.inoutdata.........");
    },
    async getheader() {
      var res = await this.$https.get(this.$url.realname.staff.datanum, "");
      if(res.code  === 200 ){
        this.zbdata[0].value = res.data.currentOnSiteCount;
        this.zbdata[1].value = res.data.dailyCumulativeOnSiteCount;
        this.zbdata[2].value = res.data.dailyEntryCount;
        this.zbdata[3].value = res.data.dailyExitCount;
        this.zbdata[4].value = res.data.managementMonthlyAttendance;
        this.zbdata[5].value = res.data.workerMonthlyAttendance;
      }

    },
    async initDoorVideo(){
      var res = await this.$https.get(this.$url.realname.staff.doorVideo, "");
      if(res.code === 200 ){
        //判断是否有数据
        if(res.data?.doorList?.length === 0){
          return
        }
         this.videoData = res.data.doorList
         this.token =  res.data?.token ;
         var list = res.data?.doorList;

         this.videoObj.equipmentId = list[0].equipmentId;
         this.videoObj.projectId = list[0].projectId;
         this.videoObj.imageUrl = list[0].photo;
         this.videoObj.liveUrl = list[0].liveUrl;
         this.videoObj.channel = list[0].ysChannelNo;

      }

    }
  },
  mounted() {
    this.initfirst();
    this.initDoorVideo();
    this.secondinit();
    this.thirdinit();
    this.getrecord();
    this.getheader();
    this.getBox()
  }
};
</script>

<style lang="scss" scoped>
.total {
  .kongbox{
      width: 100%;
      height: 100%;
      display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    >img{
      width:20%;
      margin-bottom: .625rem;
    }
  }
  .content {
    .main {
      .mainsingle {
        .inoutlist {
          .inoutsingle {
           display: flex;
           position: relative;
           .fot {
              width: 100%;
              color: #bbc6d6;
            }
            .mid {
              width: 100%;
              color: #bbc6d6;
            }
            .top {
              width: 100%;
              margin-bottom: 4%;
            }

            img {
              width: 5.3125rem;
              height: 5.3125rem;
            }


            border-radius: 0.42vw;
            width: 48%;
            height: 6.25rem;
            padding: .625rem;
            background: #16385e;
            margin: .3125rem 0;
            margin-left: .625rem;

          }
          width: 100%;
          height: 95%;
          display: flex;
          flex-wrap: wrap;
          align-content: flex-start;
          justify-content: flex-start;
          overflow: auto;
        }
        .doorlist {
          height: 100%;
          .doorsingle {
            .staffimg {
              width: 100%;
              height: 95%;
              margin-top: .625rem;
            }
            width: 100%;
            height: 100%;
          }
          width: 100%;
          height: 82%;
          padding: 0 1.04vw;
        }
        .charts {

          padding: 1.04vw;
        }

      }
      padding-left: 2.08vw;
      gap: 1.04vw;
    }
    .zbbox {
      .zblist {
        position: relative;
        > img {
          width: 2.5rem;
          margin-left: 6.7%;

          z-index: 1;
        }
        .img-back{
          position: absolute;
          height: 100%;
          z-index: 0;
          left: -3.7%;
        }
        p {

          z-index: 1;
          text-indent: 2.73vw;
          text-align: left;
          margin-left: -1.7vw;
          color: linear-gradient(90deg, #ffffff 0%, #4cbaff 100%);
        }
        height: 100%;
        width: 13.02vw;
        // background: url("../assets/image/指标背景-蓝.png") no-repeat;
        background-position: -0.52vw 0;
        background-size: contain;
        display: flex;
        align-items: center;
        justify-content: flex-start;
      }
      height: 4.46vw;
      margin: 0.52vw 0;
      width: 100%;
      padding-left: 3.13vw;
      padding-right: 2.08vw;
    }
    padding-left: 10.89vw;
    padding-right: 1.04vw;
  }
  background: url("../assets/image/bgstaff.png") no-repeat;
}

.bluebg {
  background: rgba(0, 25, 49, 0.5);
  box-shadow: inset 0px 0px 24px 0px rgba(72, 125, 163, 0.5);
  border-radius: 8px;
  border: 1px solid rgba(131, 166, 199, 0.3);
  backdrop-filter: blur(3px);
}
</style>
